import app from 'flarum/forum/app';
app.initializers.add('val-ui-group-colors', () => {
  function applyGroupColors() {
    if (!app.forum || typeof app.forum.attribute !== 'function') {
      window.setTimeout(applyGroupColors, 100);
      return;
    }
    const colors = app.forum.attribute('valGroupColors') || {};
    const rules = Object.entries(colors).filter(_ref => {
      let [id, color] = _ref;
      return /^\d+$/.test(String(id)) && /^#[0-9a-f]{3,8}$/i.test(String(color));
    }).map(_ref2 => {
      let [id, color] = _ref2;
      return `.ValGroupColor--${id} { color: ${color} !important; }`;
    });
    if (!rules.length) return;
    let style = document.getElementById('val-ui-group-colors');
    if (!style) {
      style = document.createElement('style');
      style.id = 'val-ui-group-colors';
      document.head.appendChild(style);
    }
    style.textContent = rules.join('\n');
  }
  applyGroupColors();
});